const tr = {
  nav: {
    home: 'Ana Sayfa',
    professionalServices: 'Profesyonel Hizmetler',
    solutions: 'Çözümler',
    securityProducts: 'Güvenlik Ürünleri',
    zebraProducts: 'Zebra Ürünleri',
    contact: 'İletişim',
    getQuote: 'Teklif Al',
  },
  footer: {
    quickLinks: 'Hızlı Bağlantılar',
    contactTitle: 'İletişim',
    description: 'Endüstri 4.0 Dijital Dönüşüm Sürecinde, butik uzmanlığımız ile yetkili partner olarak başarısına güvendiğimiz kurumsal çözümleri sahada sizler ile buluşturuyoruz.',
    rights: 'Tüm hakları saklıdır.',
    country: 'Türkiye',
    legal: 'Yasal',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Koşulları',
  },
  home: {
    announcements: 'Duyurular',
    ann1: 'ELC Teknoloji Fortinet Partnerı oldu, Fortinet projelerinizde de yanınızdayız.',
    ann2: 'Otel müşterimizin Fortigate geçişi başarıyla tamamlandı.',
    ann3: 'ELC Teknoloji, Zebra Technologies çözümleriyle barkod, RFID, mobil el terminali ve endüstriyel yazıcı projelerinde hizmet sunmaktadır.',
    ann4: 'ELC Teknoloji, Paessler PRTG ile ağ, sunucu ve OT altyapılarının izlenmesine yönelik kurumsal çözümler sunmaktadır.',
    ann5: 'ThreatLocker ile yalnızca izin verdiğiniz uygulamalar çalışsın. ELC Teknoloji olarak ThreatLocker yetkili bayisi olarak, Application Allowlisting ile endpoint\'lerinizi ransomware, zero-day ve yetkisiz uygulamalara karşı koruyoruz.',
    ann5Partner: 'ELC Teknoloji, ThreatLocker\'ın Katma Değerli Partneridir.',
    ann5Desc: 'Zero Trust yaklaşımıyla Application Control, Allowlisting, Ringfencing ve endpoint güvenliği çözümlerini keşfedin.',
    ann5Cta: 'ThreatLocker\'ı Keşfedin',
    swBadge: 'Yazılım & Dijital Çözümler',
    swTitle: 'Yazılım & Dijital Çözümler',
    swSubtitle: 'Web, Mobil, SaaS ve Yapay Zeka destekli özel yazılım çözümleri',
    swDesc: 'İşletmelerin dijital ihtiyaçlarına özel, modern, güvenli ve ölçeklenebilir yazılım çözümleri geliştiriyoruz. Fikirden yayına kadar uçtan uca hizmet sunuyoruz.',
    swCta: 'Projenizi Birlikte Değerlendirelim',
    swTag1: 'Web & Mobil',
    swTag2: 'SaaS',
    swTag3: 'Yapay Zeka',
    swTag4: 'Entegrasyon',
    msBadge: 'Microsoft İş Ortaklığı',
    msTitle: 'ELC Teknoloji, Microsoft İş Ortağı!',
    msDesc: 'Microsoft AI Cloud Partner ve CSP Partner kimliğimizle artık Microsoft lisanslama, Microsoft 365 ve bulut çözümlerinde kurumsal müşterilerimizin yanındayız.',
    msCta: 'Microsoft Lisanslama Desteği Al',
    msProgram: 'Microsoft AI Cloud Partner Program',
    msCsp: 'CSP Partner',
    zebraHeroTitle: 'Zebra Teknolojileri',
    zebraHeroPartner: 'ELC Teknoloji Yetkili Satış Partneridir',
    zebraHeroDesc: 'Barkod yazıcılardan barkod okuyuculara, mobil bilgisayarlardan RFID çözümlerine kadar Zebra teknolojileriyle işletmelerinizin operasyonel verimliliğini artırın.',
    zebraHeroCta: 'Zebra Çözümlerini Keşfedin',
    killdiskHeroTitle: 'Güvenli Veri İmhası ve Disk Wipe Çözümleri',
    killdiskHeroPartner: 'ELC Teknoloji, Active@ ürünlerinin Türkiye Yetkili Bayisidir.',
    killdiskHeroDesc: 'Kullanım ömrünü tamamlayan bilgisayar, HDD ve SSD\'lerde verilerin güvenli ve geri döndürülemez şekilde silinmesi için Active@ KillDisk çözümlerini keşfedin.',
    killdiskHeroCta: 'KillDisk\'i Keşfedin',
    killdiskHeroContact: 'Bilgi Al',
    fortinetHeroTitle: 'Güvenli Ağ Altyapısı. Güçlü Siber Güvenlik.',
    fortinetHeroPartner: 'ELC Teknoloji – Fortinet Çözüm Ortağı',
    fortinetHeroDesc: 'FortiGate, Secure SD-WAN, SASE ve kapsamlı ağ güvenliği çözümleriyle kurumunuzun siber güvenlik altyapısını güçlendirin.',
    fortinetHeroCta: 'Fortinet Çözümlerini Keşfedin',
    otHeroTitle: 'Kritik Altyapınızı Güvence Altına Alın',
    otHeroPartner: 'ELC Teknoloji – Endüstriyel Siber Güvenlik Çözümleri',
    otHeroDesc: 'OT, ICS ve kritik altyapı ortamlarında ağ görünürlüğünü artırın, güvenlik risklerini azaltın ve operasyonel sistemlerinizi koruyun.',
    otHeroCta: 'OT Güvenlik Çözümlerini Keşfedin',
    ann6: 'ELC Teknoloji olarak, uzaktan erişim, bağlantı yönetimi ve ayrıcalıklı erişim güvenliği çözümleri sunan Devolutions\'ın Partneri olduk. Devolutions çözümleriyle müşterilerimize güvenli ve merkezi IT erişim yönetimi sunuyoruz.',
    ann7: 'ELC Teknoloji olarak, veri silme ve disk imha güvenliği alanında Active@ KillDisk çözümlerini sunuyoruz. Active@ KillDisk, sabit disk, SSD ve diğer depolama ortamlarındaki verilerin kalıcı ve geri döndürülemez şekilde silinmesini sağlayarak kurumların veri güvenliği ve uyumluluk ihtiyaçlarını destekler.',
    heroBadge: 'Siber Güvenlik Çözümleri',
    heroTitle1: 'İşletmenizi',
    heroTitle2: 'Güvenle Koruyun',
    heroDesc: 'IT ve OT siber güvenlik çözümleri ile hem bilgi teknolojileri hem de operasyonel teknolojilerdeki potansiyel tehditlere karşı entegre koruma sağlıyoruz.',
    heroCta1: 'Güvenlik Analizi Al',
    heroCta2: 'Hizmetlerimiz',
    monitorBadge: 'Gerçek Zamanlı İzleme',
    monitorTitle: 'Güvenlik Kontrol Merkezi (SOC)',
    monitorDesc: '7/24 siber güvenlik izleme ve tehdit tespit sistemlerimizle altyapınızı sürekli koruma altında tutuyoruz.',
    threatsBlocked: 'Engellenen Tehdit',
    activeConnections: 'Aktif Bağlantı',
    systemHealth: 'Sistem Sağlığı',
    firewall: 'Firewall',
    active: 'Aktif',
    securityLogs: 'Güvenlik Logları',
    live: 'CANLI',
    log1: 'Firewall kuralları güncellendi',
    log2: 'Şüpheli IP engellendi: 45.227.253.98',
    log3: 'SSL sertifikası doğrulandı',
    log4: 'Brute force saldırısı: 91.134.182.47',
    log5: 'Malware taraması tamamlandı',
    logTime1: '2 sn önce',
    logTime2: '15 sn önce',
    logTime3: '32 sn önce',
    logTime4: '1 dk önce',
    logTime5: '2 dk önce',
    servicesBadge: 'Hizmetlerimiz',
    servicesTitle: 'Profesyonel BT Hizmetleri',
    servicesDesc: 'Endüstri 4.0 dijital dönüşüm sürecinde, butik uzmanlığımız ile kurumsal çözümleri sahada sizler ile buluşturuyoruz.',
    svc1Title: 'IT & OT Siber Güvenlik',
    svc1Desc: 'Hem bilgi teknolojileri hem de operasyonel teknolojilerdeki potansiyel tehditlere karşı entegre koruma sağlıyoruz.',
    svc2Title: 'BT Altyapı Analizi',
    svc2Desc: 'Networkünüz, sistemleriniz ve güvenliğinizin ne seviyede olduğunu analiz ediyoruz.',
    svc3Title: 'İşletim & Bakım',
    svc3Desc: 'Güçlü teknik ekibimizle altyapınızı yönetiyoruz. Hem tasarruf edin, hem risklerinizi transfer edin.',
    allServices: 'Tüm Hizmetler',
    whyUsBadge: 'Neden Biz?',
    whyUsTitle: 'ELC Teknoloji Farkı',
    why1Title: 'Uzmanlık',
    why1Desc: 'Yetkili partner olarak sektör liderlerinin çözümlerini sunuyoruz.',
    why2Title: 'Hız',
    why2Desc: 'Hızlı tedarik ve kurulum ile iş süreçlerinizi aksatmadan çözüm sağlıyoruz.',
    why3Title: 'Destek',
    why3Desc: 'Satış öncesi ve sonrası tam destek ile yanınızdayız.',
    ctaTitle: 'Altyapınızı Güvence Altına Almaya Hazır mısınız?',
    ctaDesc: 'Güvenliğinizden şüphe ediyorsanız, gelin güvenlik testlerinizi yapalım ve görünmeyen riskleri birlikte ortadan kaldıralım.',
    ctaBtn: 'Ücretsiz Değerlendirme Al',
  },
  solutions: {
    badge: 'Çözümlerimiz',
    title: 'Kurumsal BT Çözümleri',
    desc: 'Endüstri 4.0 Dijital Dönüşüm Sürecinde, butik uzmanlığımız ile yetkili partner olarak başarısına güvendiğimiz kurumsal çözümleri sahada sizler ile buluşturuyoruz.',
    sol1Title: 'Network Çözümleri',
    sol1Desc: 'Sürekli olarak teknolojiler ve ihtiyaçlar değişiyor. Network altyapınızın da bu değişimlere cevap vermesi gerekiyor. Uzman kadromuz ise sizleri daha ileri taşıyacak çözümler sunacaktır.',
    sol1Tag: 'Altyapı',
    sol2Title: 'OT Güvenlik Çözümleri',
    sol2Desc: 'Kritik Otomasyon Altyapılarınız için Siber Güvenlik Platformu sunuyoruz. OT Altyapınızdaki cihazların trafik paket analizi yaparak görmediğiniz protokollerdeki risklerinizi size online olarak gösteriyoruz.',
    sol2Tag: 'Güvenlik',
    sol3Title: 'DDoS Çözümleri',
    sol3Desc: 'DDoS Atak Önleme Çözümü ile DDoS ataklarını daha ağınıza ulaşmadan engelleyebilir ve böylece işletmenizin BT altyapısını söz konusu hedefli ataklara karşı koruyabilirsiniz.',
    sol3Tag: 'Koruma',
    sol4Title: 'KVKK Çözümleri',
    sol4Desc: '6698 Sayılı Kişisel Verilerin Korunması Kanunu kapsamında, veri güvenliğinizi sağlamaya yönelik teknik danışmanlık ve teknoloji hizmetleri sunuyoruz.',
    sol4Tag: 'Uyum',
    sol5Title: 'SIEM Çözümleri',
    sol5Desc: 'SIEM çözümlerimiz ile sizlerin tüm BT yapınızda daha proaktif olmanızı sağlıyoruz. Toplanan loglar, korelasyonlar size hem güvenlik hem de operasyon için önemli istihbarat bilgileri verir.',
    sol5Tag: 'İzleme',
    sol6Title: 'Son Kullanıcı Güvenliği',
    sol6Desc: 'Son kullanıcılar, dış tehditler için birer fırsat kapısıdır. Kurumlar olarak son kullanıcıyı dış tehditlerden korumak için son kullanıcı güvenliği ürünleri (EDR) kullanmak zorundayız.',
    sol6Tag: 'Endpoint',
    allTitle: 'Tüm Çözümlerimiz',
    allDesc: 'İşletmenizin ihtiyaçlarına göre kapsamlı BT güvenlik ve altyapı çözümleri sunuyoruz.',
    add1: 'Network Güvenlik Çözümleri',
    add2: 'DDoS Saldırı Tespit ve Engelleme',
    add3: 'Yeni Nesil IPS Çözümleri',
    add4: 'Yeni Nesil Güvenlik Duvarı',
    add5: 'Uzak Erişim VPN Çözümleri',
    add6: 'Kablosuz Ağ Güvenlik Çözümleri',
    add7: 'LAN Güvenlik Çözümleri',
    add8: 'Web Güvenliği Çözümleri',
    add9: 'Network İzleme ve Yönetim',
    add10: 'WAN Optimizasyonu',
    add11: 'Data Koruma ve Arşivleme',
    add12: 'Anti-Spam ve E-Posta Güvenliği',
    add13: 'Veri Sızma Engelleme',
    add14: 'Mobil Güvenlik Çözümleri',
    add15: 'Bulut Güvenlik Çözümleri',
    add16: 'Felaket Kurtarma ve İş Sürekliliği',
    ctaTitle: 'İşletmenize En Uygun Çözümü Birlikte Belirleyelim',
    ctaDesc: 'Uzman ekibimiz sizin için en doğru çözümü önerecektir.',
    ctaBtn: 'Ücretsiz Danışmanlık Al',
    software: {
      badge: 'Yazılım & Dijital Çözümler',
      title: 'Yazılım & Dijital Çözümler',
      desc: 'İşletmelerin dijital ihtiyaçlarına özel, modern, güvenli ve ölçeklenebilir yazılım çözümleri geliştiriyoruz. Fikirden tasarıma, geliştirmeden entegrasyona ve yayına kadar uçtan uca hizmet sunuyoruz.',
      items: [
        { title: 'Premium Web Tasarım & Geliştirme', desc: 'Markanızı yansıtan, hızlı, mobil uyumlu ve dönüşüm odaklı kurumsal web siteleri tasarlıyor ve geliştiriyoruz.' },
        { title: 'Özel Web Yazılım Uygulamaları', desc: 'İş süreçlerinize özel, ölçeklenebilir ve güvenli web tabanlı yazılım uygulamaları geliştiriyoruz.' },
        { title: 'iOS & Android Mobil Uygulama Geliştirme', desc: 'Native ve cross-platform teknolojilerle yüksek performanslı iOS ve Android mobil uygulamalar üretiyoruz.' },
        { title: 'Kurumsal Portal ve Müşteri/Bayi Portalları', desc: 'Müşteri, bayi ve iş ortaklarınız için güvenli ve entegre kurumsal portal çözümleri sunuyoruz.' },
        { title: 'E-Ticaret Çözümleri', desc: 'Yüksek trafiğe hazır, güvenli ödeme altyapılı ve yönetimi kolay e-ticaret platformları kuruyoruz.' },
        { title: 'API ve Yazılım Entegrasyonları', desc: 'Sistemlerinizi birbirine bağlayan güvenli ve sürdürülebilir API ve yazılım entegrasyonları geliştiriyoruz.' },
        { title: 'ERP / CRM Entegrasyonları', desc: 'Mevcut ERP ve CRM sistemlerinizi uygulamalarınızla kesintisiz şekilde entegre ediyoruz.' },
        { title: 'Ödeme, SMS, WhatsApp ve Üçüncü Parti Entegrasyonları', desc: 'Ödeme, SMS, WhatsApp ve üçüncü parti servisleri iş akışlarınıza sorunsuz şekilde entegre ediyoruz.' },
        { title: 'SaaS Uygulama Geliştirme', desc: 'Abonelik tabanlı, çok kiracılı (multi-tenant) ve bulutta çalışan SaaS ürünleri geliştiriyoruz.' },
        { title: 'Yapay Zeka ve AI Destekli Uygulamalar', desc: 'Yapay zeka ve makine öğrenmesiyle güçlendirilmiş akıllı ve veri odaklı uygulamalar tasarlıyoruz.' },
        { title: 'İş Süreçleri Otomasyonu', desc: 'Tekrarlayan iş süreçlerini otomatize ederek verimliliği ve operasyonel hızı artırıyoruz.' },
        { title: 'Cloud & DevOps', desc: 'Ölçeklenebilir bulut altyapıları, CI/CD ve DevOps süreçleriyle güvenli ve kesintisiz yayın sağlıyoruz.' },
        { title: 'Özel Yazılım Geliştirme', desc: 'Kurumunuzun kendine özgü ihtiyaçlarına yönelik uçtan uca özel yazılım çözümleri geliştiriyoruz.' },
      ],
      ctaTitle: 'Projenizi Birlikte Hayata Geçirelim',
      ctaBtn: 'Projeyi Başlatalım',
    },
  },
  security: {
    badge: 'Siber Güvenlik Ürünleri',
    title: 'Kurumsal Güvenlik Çözümleri',
    desc: 'Dünya lideri markalarla işbirliği içinde, IT ve OT ortamlarınız için en kapsamlı siber güvenlik ürünlerini sunuyoruz.',
    features: 'Özellikler',
    benefits: 'Avantajlar',
    ctaTitle: 'İşletmeniz İçin En Uygun Çözümü Belirleyelim',
    ctaDesc: 'Uzman ekibimiz, altyapınızı analiz ederek size en uygun siber güvenlik ürünlerini önerecektir.',
    ctaBtn: 'Ücretsiz Demo Talep Et',
    honeywell: {
      tagline: 'OT Siber Güvenlik Platformu',
      desc: 'Honeywell Cyber Insights, endüstriyel kontrol sistemleri (ICS) ve operasyonel teknoloji (OT) ağlarını korumak için tasarlanmış kapsamlı bir siber güvenlik çözümüdür.',
      f1: 'OT ağlarında tam görünürlük ve varlık keşfi',
      f2: 'Pasif IOC (Uzlaşma Göstergesi) tespiti',
      f3: 'AI/ML tabanlı proaktif savunma',
      f4: '24/7/365 Security Operations Center (SOC)',
      f5: 'Satıcı bağımsız ve ajansız çalışma',
      f6: 'MITRE ATT&CK entegrasyonu',
      b1: 'Erken tehdit uyarısı',
      b2: 'Düşük false positive oranı',
      b3: 'Operasyonel süreklilik',
      b4: 'NIS 2 uyumluluk desteği',
    },
    fortinet: {
      tagline: 'Yeni Nesil Güvenlik Duvarı',
      desc: 'Fortinet FortiGate, dünyanın en çok tercih edilen yeni nesil güvenlik duvarı (NGFW) çözümüdür. SD-WAN, IPS, antivirüs, web filtreleme ve VPN özelliklerini tek platformda sunar.',
      f1: 'FortiGuard AI destekli tehdit koruması',
      f2: 'SD-WAN entegrasyonu',
      f3: 'SSL/TLS denetimi',
      f4: 'Zero Trust Network Access (ZTNA)',
      f5: 'Bulut ve on-premise esnekliği',
      f6: 'Merkezi yönetim (FortiManager)',
      b1: 'Düşük TCO (Toplam Sahip Olma Maliyeti)',
      b2: 'Gartner lider konumu',
      b3: 'Yüksek performans/güvenlik dengesi',
      b4: 'Kolay yönetim ve raporlama',
    },
    checkpoint: {
      tagline: 'Kurumsal Siber Güvenlik',
      desc: 'Check Point, dünya lideri kurumsal siber güvenlik çözümleri sunan bir markadır. Ağ, bulut, mobil ve uç nokta güvenliği için kapsamlı koruma sağlar.',
      f1: 'Quantum güvenlik ağ geçitleri',
      f2: 'CloudGuard bulut güvenliği',
      f3: 'Harmony uç nokta koruması',
      f4: 'ThreatCloud AI tehdit istihbaratı',
      f5: 'Infinity SOC yönetimi',
      f6: 'Zero-day tehdit önleme',
      b1: '30 yıllık siber güvenlik deneyimi',
      b2: 'Entegre güvenlik mimarisi',
      b3: 'Gerçek zamanlı tehdit istihbaratı',
      b4: 'Fortune 100 güvencesi',
    },
    bitraser: {
      tagline: 'Sertifikalı Veri İmha Yazılımı',
      desc: 'BitRaser, kurumsal cihazlardaki hassas verileri kalıcı ve geri getirilemez şekilde silen sertifikalı veri imha yazılımıdır. HDD, SSD, sunucu ve mobil cihazlarda denetlenebilir imha raporları üretir.',
      f1: 'Uluslararası standartlarda kalıcı veri silme (NIST 800-88 vb.)',
      f2: 'Kurcalanamaz dijital imha sertifikaları ve raporları',
      f3: 'HDD, SSD, sunucu ve mobil cihaz desteği',
      f4: '24+ küresel silme standardı',
      f5: 'Toplu ve uzaktan silme yönetimi',
      f6: 'Denetim ve uyumluluk için detaylı kayıt',
      b1: 'KVKK ve GDPR uyumluluğu',
      b2: 'Geri getirilemez veri güvenliği',
      b3: 'Denetlenebilir imha kanıtı',
      b4: 'Kurumsal ölçeklenebilirlik',
    },
    activedatadisk: {
      tagline: 'Veri Kurtarma ve Disk Yönetimi',
      desc: 'Active@ Data Disk, veri kurtarma, disk yönetimi ve güvenli silme çözümleri sunan profesyonel yazılım paketidir. Kayıp verileri kurtarın, diskleri yönetin.',
      f1: 'Silinen dosya kurtarma',
      f2: 'Bozuk disk onarımı',
      f3: 'Güvenli veri silme (DoD standardı)',
      f4: 'Disk klonlama ve görüntüleme',
      f5: 'Partition yönetimi',
      f6: 'Boot disk oluşturma',
      b1: 'Kolay kullanımlı arayüz',
      b2: 'Kapsamlı dosya sistemi desteği',
      b3: 'Profesyonel veri kurtarma',
      b4: 'Uygun fiyatlı lisanslama',
    },
    garland: {
      tagline: 'Network TAP Çözümleri',
      desc: 'Garland Technology Network TAP\'leri, ağ trafiğini kesintisiz kopyalayarak güvenlik ve izleme araçlarına tam veri görünürlüğü sağlayan donanım çözümleridir.',
      f1: 'Tam paket görünürlüğü - hiç paket kaybı yok',
      f2: 'Bypass modu ile kesintisiz ağ akışı',
      f3: 'Aktif filtreleme ve trafik birleştirme',
      f4: 'Sanal ortam desteği (Virtual TAP)',
      f5: 'Multi-vendor uyumluluk',
      f6: 'Inline güvenlik araç desteği',
      b1: 'SPOF eliminasyonu',
      b2: 'Optimal araç performansı',
      b3: 'Ağa sıfır ek yük',
      b4: 'Bulut entegrasyonu',
    },
    threatlocker: {
      tagline: 'Zero Trust Uygulama Kontrolü',
      desc: 'ThreatLocker, Zero Trust tabanlı uygulama kontrolü ve endpoint güvenliği çözümleri sunan lider bir platformdur. Application Allowlisting ile yalnızca onayladığınız uygulamaların çalışmasına izin vererek ransomware, zero-day ve yetkisiz yazılımlara karşı koruma sağlar.',
      f1: 'Application Allowlisting (Uygulama Beyaz Liste)',
      f2: 'Ringfencing™ - Uygulama izolasyonu',
      f3: 'Storage Control - Depolama erişim kontrolü',
      f4: 'Elevation Control - Yetki yükseltme yönetimi',
      f5: 'Network Control - Ağ erişim kontrolü',
      f6: 'Unified Audit - Merkezi denetim ve raporlama',
      b1: 'Ransomware koruması',
      b2: 'Zero-day tehdit önleme',
      b3: 'Kolay yönetim ve dağıtım',
      b4: 'Düşük sistem etkisi',
    },
    salvador: {
      tagline: 'OT Siber Esneklik Platformu',
      desc: 'Salvador Technologies, OT ve ICS ortamları için özel tasarlanmış, ultra hızlı yedekleme ve kurtarma çözümü sunan siber esneklik platformudur.',
      f1: '30 saniyede sistem restore',
      f2: 'Donanım tabanlı hava boşluğu (air-gap) koruması',
      f3: 'AI destekli yedek bütünlüğü doğrulaması',
      f4: 'Şifreli veri koruması',
      f5: 'HMI, SCADA, DCS desteği',
      f6: 'Bulut ve on-premise seçenekleri',
      b1: '1 dakikadan kısa tam kurtarma',
      b2: 'Ransomware koruması',
      b3: 'Uzman gerektirmez',
      b4: 'Fortune 500 güvencesi',
    },
    olympos: {
      tagline: 'Yerli Otomasyon ve SIEM Platformu',
      desc: 'BTS Olympos, Türkiye\'nin yerli otomasyon platformudur. Ağ ve sistem cihazlarını tek merkezden izleme, log yönetimi ve siber güvenlik otomasyonu sağlar.',
      f1: 'Merkezi ağ ve sistem izleme',
      f2: 'Kural tabanlı otomasyon',
      f3: 'Gelişmiş log yönetimi ve analiz',
      f4: 'Multi-vendor cihaz desteği',
      f5: 'GRC (Governance, Risk, Compliance)',
      f6: 'Yapay zeka destekli analitik',
      b1: 'Yerli ve milli çözüm',
      b2: 'ISO 27001 sertifikalı',
      b3: 'TÜBİTAK destekli Ar-Ge',
      b4: 'Türkçe destek',
    },
  },
  zebra: {
    partnerBadge: 'Zebra Yetkili Satış Partneri',
    title: 'Zebra Yazıcı ve Barkod Ürünleri',
    desc: 'ELC Teknoloji San ve Tic Ltd Şti, Türkiye genelinde Zebra Technologies markalı barkod yazıcı, mobil el terminalleri ve aksesuar satışı ile ürün danışmanlığı sunmaktadır.',
    p1Title: 'Mobil El Terminalleri',
    p1Desc: 'Depo, lojistik ve saha operasyonları için yüksek performanslı mobil el terminalleri.',
    p1f1: 'Dayanıklı Tasarım', p1f2: 'Uzun Pil Ömrü', p1f3: 'Hızlı Tarama', p1f4: 'Android İşletim Sistemi',
    p2Title: 'Zebra Yazıcılar',
    p2Desc: 'Endüstriyel ve masaüstü barkod yazıcılar ile etiketleme ihtiyaçlarınıza çözüm.',
    p2f1: 'Yüksek Baskı Kalitesi', p2f2: 'Hızlı Baskı', p2f3: 'Kolay Kullanım', p2f4: 'Düşük Bakım Maliyeti',
    p3Title: 'Barkod Okuyucular',
    p3Desc: 'Perakende, depo ve üretim ortamları için profesyonel barkod okuyucu çözümleri.',
    p3f1: '1D/2D Tarama', p3f2: 'Kablosuz Bağlantı', p3f3: 'Ergonomik Tasarım', p3f4: 'Hızlı Okuma',
    p4Title: 'Mobil Bilgisayarlar',
    p4Desc: 'Zorlu ortamlara uygun dayanıklı mobil bilgisayarlar ve tablet çözümleri.',
    p4f1: 'IP67 Koruma', p4f2: 'Geniş Ekran', p4f3: 'Güçlü İşlemci', p4f4: 'Entegre Tarayıcı',
    whyBadge: 'Neden ELC Teknoloji?',
    whyTitle: 'Zebra Ürünlerinde Güvenilir Partneriniz',
    whyDesc: 'Depo, lojistik, üretim, perakende ve saha operasyonları için en doğru Zebra barkod çözümlerini ihtiyaca göre öneriyoruz.',
    why1: 'Türkiye Geneli Satış & Hızlı Tedarik',
    why2: 'Zebra Ürünlerinde Uzmanlık',
    why3: 'İşletmeye Özel Ürün Danışmanlığı',
    why4: 'Kurumsal ve KOBİ Odaklı Çözümler',
    why5: 'Satış Öncesi & Sonrası Destek',
    ctaTitle: 'Hızlı Teklif & İletişim',
    ctaDesc: 'Zebra yazıcı satın almak, barkod çözümleri hakkında bilgi almak veya işletmenize en uygun modeli öğrenmek için hemen ulaşın.',
    ctaBtn: 'Teklif Al',
  },
  contact: {
    badge: 'İletişim',
    title: 'Bizimle İletişime Geçin',
    desc: 'Sorularınız için bize ulaşın. En kısa sürede size dönüş yapacağız.',
    infoTitle: 'İletişim Bilgileri',
    email: 'E-posta',
    phoneLabel: 'Telefon / WhatsApp',
    hours: 'Çalışma Saatleri',
    hoursValue: 'Pazartesi - Cuma: 09:00 - 18:00',
    quickSupport: 'Hızlı Destek',
    quickSupportDesc: 'Acil durumlar için WhatsApp üzerinden bize ulaşabilirsiniz. En kısa sürede size dönüş yapacağız.',
    formTitle: 'Mesaj Gönderin',
    firstName: 'Adınız',
    lastName: 'Soyadınız',
    emailLabel: 'E-posta Adresiniz',
    phoneInput: 'Telefonunuz',
    messageLabel: 'Mesajınız',
    messagePlaceholder: 'Mesajınızı buraya yazın...',
    submit: 'Gönder',
    sending: 'Gönderiliyor...',
    successTitle: 'Teşekkürler!',
    successDesc: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
    successToast: 'Mesajınız başarıyla gönderildi!',
    errorToast: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
    newMessage: 'Yeni Mesaj Gönder',
    officesTitle: 'Ofis Lokasyonlarımız',
    officesDesc: 'Türkiye ve Amerika\'daki ofislerimizle size en yakın noktadan hizmet veriyoruz.',
    merkez: 'MERKEZ OFİS',
    gebze: 'GEBZE OFİS',
    usa: 'USA OFİS',
    taxOffice: 'Vergi Dairesi',
    taxNumber: 'Vergi Numarası',
  },
  profServices: {
    badge: 'Profesyonel BT & OT Hizmetleri',
    title1: 'Katma Değerli',
    title2: 'Profesyonel Hizmetler',
    desc: 'Danışmanlık, kurulum, işletim bakım, SOC, eğitim, kırmızı takım çözümleri ve siber olay müdahale hizmetleri.',
    navConsulting: 'Danışmanlık',
    navInstallation: 'Kurulum',
    navOperation: 'İşletim & Bakım',
    navSoc: 'SoC',
    navRedteam: 'Kırmızı Takım',
    navIncident: 'Olay Müdahale',
    navTraining: 'Akademi',
    s1Title: 'Analiz ve Danışmanlık',
    s1Desc: 'Mevcut altyapınızı analiz eder, boşlukları tespit eder ve geleceğe yönelik mimari tasarımlar oluştururuz.',
    s2Title: 'Kurulum ve Entegrasyon',
    s2Desc: 'En son teknoloji ürünlerini kurumunuza entegre ediyor, sorunsuz geçiş süreçleri sağlıyoruz.',
    s3Title: 'İşletim ve Bakım (SLA)',
    s3Desc: 'SLA garantili profesyonel işletim ve bakım hizmetleri ile sistemlerinizin kesintisiz çalışmasını sağlıyoruz.',
    slaWeekday: 'Hafta içi, 08:00–18:00',
    sla247: '7 gün, 24 saat',
    s4Title: 'On-Prem SoC Hizmetleri',
    s4Desc: 'Yerinde SoC hizmetlerimiz ile 7/24 güvenlik operasyonları yönetimi.',
    blueTeam: 'Mavi Takım SoC Hizmetleri',
    redTeamSoc: 'Kırmızı Takım SoC Hizmetleri',
    s5Title: 'Kırmızı Takım Siber Güvenlik Hizmetleri',
    s5Desc: 'BAS, saldırı simülasyonları ve masabaşı tatbikat hizmetleri ile güvenliğinizi sınayın.',
    s6Title: 'Siber Olay Müdahale Hizmetleri',
    s6Desc: 'Siber saldırılara karşı hızlı, etkili müdahale ve kurtarma hizmetleri.',
    s7Title: 'Siber Güvenlik Akademisi',
    s7Desc: 'Uzman eğitmenlerimizle teorik bilgiyi pratik deneyimle birleştiren kapsamlı eğitim programları.',
    ctaTitle: 'Teklif Alın',
    ctaDesc: 'İhtiyaçlarınıza ve kurumunuzun ölçeğine göre özelleştirilmiş hizmet paketleri için teklif isteyin. En kısa sürede size dönüş yapalım.',
    ctaBtn: 'İletişime Geçin',
  },
};

const en = {
  nav: {
    home: 'Home',
    professionalServices: 'Professional Services',
    solutions: 'Solutions',
    securityProducts: 'Security Products',
    zebraProducts: 'Zebra Products',
    contact: 'Contact',
    getQuote: 'Get Quote',
  },
  footer: {
    quickLinks: 'Quick Links',
    contactTitle: 'Contact',
    description: 'In the Industry 4.0 Digital Transformation Process, we bring enterprise solutions to the field with our boutique expertise as an authorized partner.',
    rights: 'All rights reserved.',
    country: 'Turkey',
    legal: 'Legal',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
  home: {
    announcements: 'Announcements',
    ann1: 'ELC Teknoloji became a Fortinet Partner — we are by your side for your Fortinet projects.',
    ann2: 'Our hotel client\'s Fortigate migration has been successfully completed.',
    ann3: 'ELC Teknoloji provides barcode, RFID, mobile handheld terminal and industrial printer solutions with Zebra Technologies.',
    ann4: 'ELC Teknoloji offers enterprise solutions for monitoring network, server and OT infrastructures with Paessler PRTG.',
    ann5: 'Only allow the applications you approve with ThreatLocker. As an authorized ThreatLocker reseller, ELC Teknoloji protects your endpoints against ransomware, zero-day threats, and unauthorized applications with Application Allowlisting.',
    ann5Partner: 'ELC Teknoloji is a ThreatLocker Value-Added Partner.',
    ann5Desc: 'Discover Application Control, Allowlisting, Ringfencing and endpoint security solutions with Zero Trust approach.',
    ann5Cta: 'Explore ThreatLocker',
    swBadge: 'Software & Digital Solutions',
    swTitle: 'Software & Digital Solutions',
    swSubtitle: 'Custom software solutions powered by Web, Mobile, SaaS and AI',
    swDesc: 'We develop modern, secure and scalable software solutions tailored to the digital needs of businesses. From idea to launch, we provide end-to-end services.',
    swCta: 'Let\'s Evaluate Your Project Together',
    swTag1: 'Web & Mobile',
    swTag2: 'SaaS',
    swTag3: 'AI',
    swTag4: 'Integration',
    msBadge: 'Microsoft Partnership',
    msTitle: 'ELC Teknoloji, Microsoft Partner!',
    msDesc: 'As a Microsoft AI Cloud Partner and CSP Partner, we support our enterprise customers with Microsoft licensing, Microsoft 365, and cloud solutions.',
    msCta: 'Get Microsoft Licensing Support',
    msProgram: 'Microsoft AI Cloud Partner Program',
    msCsp: 'CSP Partner',
    zebraHeroTitle: 'Zebra Technologies',
    zebraHeroPartner: 'ELC Teknoloji is an Authorized Sales Partner',
    zebraHeroDesc: 'From barcode printers to barcode scanners, mobile computers to RFID solutions — increase your business operational efficiency with Zebra technologies.',
    zebraHeroCta: 'Explore Zebra Solutions',
    killdiskHeroTitle: 'Secure Data Erasure and Disk Wipe Solutions',
    killdiskHeroPartner: 'ELC Teknoloji is an Authorized Reseller of Active@ products in Turkey.',
    killdiskHeroDesc: 'Discover Active@ KillDisk solutions for secure and irreversible data erasure on end-of-life computers, HDDs and SSDs.',
    killdiskHeroCta: 'Explore KillDisk',
    killdiskHeroContact: 'Get Info',
    fortinetHeroTitle: 'Secure Network Infrastructure. Strong Cybersecurity.',
    fortinetHeroPartner: 'ELC Teknoloji – Fortinet Solution Partner',
    fortinetHeroDesc: 'Strengthen your organization\'s cybersecurity infrastructure with FortiGate, Secure SD-WAN, SASE and comprehensive network security solutions.',
    fortinetHeroCta: 'Explore Fortinet Solutions',
    otHeroTitle: 'Secure Your Critical Infrastructure',
    otHeroPartner: 'ELC Teknoloji – Industrial Cybersecurity Solutions',
    otHeroDesc: 'Increase network visibility, reduce security risks and protect your operational systems in OT, ICS and critical infrastructure environments.',
    otHeroCta: 'Explore OT Security Solutions',
    ann6: 'ELC Teknoloji is now a Devolutions Partner, offering remote access, connection management and privileged access security solutions. We provide secure and centralized IT access management to our customers with Devolutions solutions.',
    ann7: 'ELC Teknoloji offers Active@ KillDisk solutions for data erasure and disk destruction security. Active@ KillDisk ensures permanent and irreversible deletion of data on hard drives, SSDs, and other storage media, supporting organizations\' data security and compliance needs.',
    heroBadge: 'Cybersecurity Solutions',
    heroTitle1: 'Protect Your',
    heroTitle2: 'Business Securely',
    heroDesc: 'We provide integrated protection against potential threats in both information technologies and operational technologies with IT and OT cybersecurity solutions.',
    heroCta1: 'Get Security Analysis',
    heroCta2: 'Our Services',
    monitorBadge: 'Real-Time Monitoring',
    monitorTitle: 'Security Operations Center (SOC)',
    monitorDesc: 'We keep your infrastructure under continuous protection with our 24/7 cybersecurity monitoring and threat detection systems.',
    threatsBlocked: 'Threats Blocked',
    activeConnections: 'Active Connections',
    systemHealth: 'System Health',
    firewall: 'Firewall',
    active: 'Active',
    securityLogs: 'Security Logs',
    live: 'LIVE',
    log1: 'Firewall rules updated',
    log2: 'Suspicious IP blocked: 45.227.253.98',
    log3: 'SSL certificate verified',
    log4: 'Brute force attack: 91.134.182.47',
    log5: 'Malware scan completed',
    logTime1: '2 sec ago',
    logTime2: '15 sec ago',
    logTime3: '32 sec ago',
    logTime4: '1 min ago',
    logTime5: '2 min ago',
    servicesBadge: 'Our Services',
    servicesTitle: 'Professional IT Services',
    servicesDesc: 'In the Industry 4.0 digital transformation process, we bring enterprise solutions to the field with our boutique expertise.',
    svc1Title: 'IT & OT Cybersecurity',
    svc1Desc: 'We provide integrated protection against potential threats in both information technologies and operational technologies.',
    svc2Title: 'IT Infrastructure Analysis',
    svc2Desc: 'We analyze the level of your network, systems, and security posture.',
    svc3Title: 'Operations & Maintenance',
    svc3Desc: 'We manage your infrastructure with our strong technical team. Save costs and transfer your risks.',
    allServices: 'All Services',
    whyUsBadge: 'Why Us?',
    whyUsTitle: 'The ELC Teknoloji Difference',
    why1Title: 'Expertise',
    why1Desc: 'As an authorized partner, we offer solutions from industry leaders.',
    why2Title: 'Speed',
    why2Desc: 'We provide solutions with fast procurement and installation without disrupting your business processes.',
    why3Title: 'Support',
    why3Desc: 'We are by your side with full pre-sales and post-sales support.',
    ctaTitle: 'Ready to Secure Your Infrastructure?',
    ctaDesc: 'If you have doubts about your security, let us run your security tests and eliminate hidden risks together.',
    ctaBtn: 'Get Free Assessment',
  },
  solutions: {
    badge: 'Our Solutions',
    title: 'Enterprise IT Solutions',
    desc: 'In the Industry 4.0 Digital Transformation Process, we bring enterprise solutions to the field with our boutique expertise as an authorized partner.',
    sol1Title: 'Network Solutions',
    sol1Desc: 'Technologies and needs are constantly changing. Your network infrastructure needs to respond to these changes. Our expert team will offer solutions to take you further.',
    sol1Tag: 'Infrastructure',
    sol2Title: 'OT Security Solutions',
    sol2Desc: 'We offer a Cybersecurity Platform for your Critical Automation Infrastructures. By performing traffic packet analysis of devices in your OT Infrastructure, we show you the risks in protocols you cannot see.',
    sol2Tag: 'Security',
    sol3Title: 'DDoS Solutions',
    sol3Desc: 'With our DDoS Attack Prevention Solution, you can block DDoS attacks before they reach your network and protect your enterprise IT infrastructure against targeted attacks.',
    sol3Tag: 'Protection',
    sol4Title: 'GDPR Solutions',
    sol4Desc: 'We provide technical consultancy and technology services to ensure your data security within the scope of the Personal Data Protection Law.',
    sol4Tag: 'Compliance',
    sol5Title: 'SIEM Solutions',
    sol5Desc: 'With our SIEM solutions, we enable you to be more proactive across your entire IT structure. Collected logs and correlations provide important intelligence for both security and operations.',
    sol5Tag: 'Monitoring',
    sol6Title: 'Endpoint Security',
    sol6Desc: 'End users are opportunity gates for external threats. As organizations, we must use endpoint security products (EDR) to protect end users from external threats.',
    sol6Tag: 'Endpoint',
    allTitle: 'All Our Solutions',
    allDesc: 'We offer comprehensive IT security and infrastructure solutions according to your business needs.',
    add1: 'Network Security Solutions',
    add2: 'DDoS Attack Detection & Prevention',
    add3: 'Next-Gen IPS Solutions',
    add4: 'Next-Gen Firewall',
    add5: 'Remote Access VPN Solutions',
    add6: 'Wireless Network Security',
    add7: 'LAN Security Solutions',
    add8: 'Web Security Solutions',
    add9: 'Network Monitoring & Management',
    add10: 'WAN Optimization',
    add11: 'Data Protection & Archiving',
    add12: 'Anti-Spam & Email Security',
    add13: 'Data Leak Prevention',
    add14: 'Mobile Security Solutions',
    add15: 'Cloud Security Solutions',
    add16: 'Disaster Recovery & Business Continuity',
    ctaTitle: 'Let\'s Determine the Best Solution for Your Business Together',
    ctaDesc: 'Our expert team will recommend the right solution for you.',
    ctaBtn: 'Get Free Consultation',
    software: {
      badge: 'Software & Digital Solutions',
      title: 'Software & Digital Solutions',
      desc: 'We develop modern, secure and scalable software solutions tailored to the digital needs of businesses. From idea to design, development to integration and launch, we provide end-to-end services.',
      items: [
        { title: 'Premium Web Design & Development', desc: 'We design and build brand-focused, fast, mobile-friendly and conversion-oriented corporate websites.' },
        { title: 'Custom Web Software Applications', desc: 'We develop scalable and secure web-based software applications tailored to your business processes.' },
        { title: 'iOS & Android Mobile App Development', desc: 'We build high-performance iOS and Android apps using native and cross-platform technologies.' },
        { title: 'Corporate & Customer/Dealer Portals', desc: 'We deliver secure and integrated corporate portal solutions for your customers, dealers and partners.' },
        { title: 'E-Commerce Solutions', desc: 'We build high-traffic-ready e-commerce platforms with secure payment infrastructure and easy management.' },
        { title: 'API & Software Integrations', desc: 'We develop secure and sustainable API and software integrations that connect your systems.' },
        { title: 'ERP / CRM Integrations', desc: 'We seamlessly integrate your existing ERP and CRM systems with your applications.' },
        { title: 'Payment, SMS, WhatsApp & Third-Party Integrations', desc: 'We seamlessly integrate payment, SMS, WhatsApp and third-party services into your workflows.' },
        { title: 'SaaS Application Development', desc: 'We build subscription-based, multi-tenant and cloud-native SaaS products.' },
        { title: 'AI-Powered Applications', desc: 'We design smart, data-driven applications powered by artificial intelligence and machine learning.' },
        { title: 'Business Process Automation', desc: 'We automate repetitive business processes to boost efficiency and operational speed.' },
        { title: 'Cloud & DevOps', desc: 'We provide scalable cloud infrastructure, CI/CD and DevOps for secure and uninterrupted delivery.' },
        { title: 'Custom Software Development', desc: 'We develop end-to-end custom software solutions tailored to your organization\'s unique needs.' },
      ],
      ctaTitle: 'Let\'s Bring Your Project to Life Together',
      ctaBtn: 'Start Your Project',
    },
  },
  security: {
    badge: 'Cybersecurity Products',
    title: 'Enterprise Security Solutions',
    desc: 'In collaboration with world-leading brands, we offer the most comprehensive cybersecurity products for your IT and OT environments.',
    features: 'Features',
    benefits: 'Benefits',
    ctaTitle: 'Let\'s Determine the Best Solution for Your Business',
    ctaDesc: 'Our expert team will analyze your infrastructure and recommend the most suitable cybersecurity products.',
    ctaBtn: 'Request Free Demo',
    honeywell: {
      tagline: 'OT Cybersecurity Platform',
      desc: 'Honeywell Cyber Insights is a comprehensive cybersecurity solution designed to protect industrial control systems (ICS) and operational technology (OT) networks.',
      f1: 'Full visibility and asset discovery in OT networks',
      f2: 'Passive IOC (Indicator of Compromise) detection',
      f3: 'AI/ML-based proactive defense',
      f4: '24/7/365 Security Operations Center (SOC)',
      f5: 'Vendor-independent and agentless operation',
      f6: 'MITRE ATT&CK integration',
      b1: 'Early threat warning',
      b2: 'Low false positive rate',
      b3: 'Operational continuity',
      b4: 'NIS 2 compliance support',
    },
    fortinet: {
      tagline: 'Next-Generation Firewall',
      desc: 'Fortinet FortiGate is the world\'s most preferred next-generation firewall (NGFW) solution. It offers SD-WAN, IPS, antivirus, web filtering and VPN features in a single platform.',
      f1: 'FortiGuard AI-powered threat protection',
      f2: 'SD-WAN integration',
      f3: 'SSL/TLS inspection',
      f4: 'Zero Trust Network Access (ZTNA)',
      f5: 'Cloud and on-premise flexibility',
      f6: 'Centralized management (FortiManager)',
      b1: 'Low TCO (Total Cost of Ownership)',
      b2: 'Gartner leader position',
      b3: 'High performance/security balance',
      b4: 'Easy management and reporting',
    },
    checkpoint: {
      tagline: 'Enterprise Cybersecurity',
      desc: 'Check Point is a world-leading brand offering enterprise cybersecurity solutions. It provides comprehensive protection for network, cloud, mobile and endpoint security.',
      f1: 'Quantum security gateways',
      f2: 'CloudGuard cloud security',
      f3: 'Harmony endpoint protection',
      f4: 'ThreatCloud AI threat intelligence',
      f5: 'Infinity SOC management',
      f6: 'Zero-day threat prevention',
      b1: '30 years of cybersecurity experience',
      b2: 'Integrated security architecture',
      b3: 'Real-time threat intelligence',
      b4: 'Fortune 100 trust',
    },
    bitraser: {
      tagline: 'Certified Data Erasure Software',
      desc: 'BitRaser is certified data erasure software that permanently and irreversibly wipes sensitive data from enterprise devices, generating auditable erasure reports for HDDs, SSDs, servers and mobile devices.',
      f1: 'Permanent data erasure to international standards (NIST 800-88, etc.)',
      f2: 'Tamper-proof digital erasure certificates and reports',
      f3: 'Support for HDD, SSD, server and mobile devices',
      f4: '24+ global erasure standards',
      f5: 'Bulk and remote erasure management',
      f6: 'Detailed logging for audit and compliance',
      b1: 'KVKK & GDPR compliance',
      b2: 'Irreversible data security',
      b3: 'Auditable proof of erasure',
      b4: 'Enterprise scalability',
    },
    activedatadisk: {
      tagline: 'Data Recovery & Disk Management',
      desc: 'Active@ Data Disk is a professional software package offering data recovery, disk management and secure deletion solutions. Recover lost data and manage disks.',
      f1: 'Deleted file recovery',
      f2: 'Corrupted disk repair',
      f3: 'Secure data deletion (DoD standard)',
      f4: 'Disk cloning and imaging',
      f5: 'Partition management',
      f6: 'Boot disk creation',
      b1: 'User-friendly interface',
      b2: 'Comprehensive file system support',
      b3: 'Professional data recovery',
      b4: 'Affordable licensing',
    },
    garland: {
      tagline: 'Network TAP Solutions',
      desc: 'Garland Technology Network TAPs are hardware solutions that provide full data visibility to security and monitoring tools by seamlessly copying network traffic.',
      f1: 'Full packet visibility - zero packet loss',
      f2: 'Bypass mode for uninterrupted network flow',
      f3: 'Active filtering and traffic aggregation',
      f4: 'Virtual environment support (Virtual TAP)',
      f5: 'Multi-vendor compatibility',
      f6: 'Inline security tool support',
      b1: 'SPOF elimination',
      b2: 'Optimal tool performance',
      b3: 'Zero overhead on network',
      b4: 'Cloud integration',
    },
    threatlocker: {
      tagline: 'Zero Trust Application Control',
      desc: 'ThreatLocker is a leading platform offering Zero Trust application control and endpoint security solutions. It protects against ransomware, zero-day threats, and unauthorized software by allowing only approved applications to run through Application Allowlisting.',
      f1: 'Application Allowlisting',
      f2: 'Ringfencing™ - Application isolation',
      f3: 'Storage Control - Storage access management',
      f4: 'Elevation Control - Privilege elevation management',
      f5: 'Network Control - Network access control',
      f6: 'Unified Audit - Centralized auditing and reporting',
      b1: 'Ransomware protection',
      b2: 'Zero-day threat prevention',
      b3: 'Easy management and deployment',
      b4: 'Low system impact',
    },
    salvador: {
      tagline: 'OT Cyber Resilience Platform',
      desc: 'Salvador Technologies is a cyber resilience platform offering ultra-fast backup and recovery solutions specially designed for OT and ICS environments.',
      f1: '30-second system restore',
      f2: 'Hardware-based air-gap protection',
      f3: 'AI-powered backup integrity verification',
      f4: 'Encrypted data protection',
      f5: 'HMI, SCADA, DCS support',
      f6: 'Cloud and on-premise options',
      b1: 'Full recovery in under 1 minute',
      b2: 'Ransomware protection',
      b3: 'No expert required',
      b4: 'Fortune 500 assurance',
    },
    olympos: {
      tagline: 'Domestic Automation and SIEM Platform',
      desc: 'BTS Olympos is Turkey\'s domestic automation platform. It provides centralized monitoring, log management, and cybersecurity automation for network and system devices.',
      f1: 'Centralized network and system monitoring',
      f2: 'Rule-based automation',
      f3: 'Advanced log management and analysis',
      f4: 'Multi-vendor device support',
      f5: 'GRC (Governance, Risk, Compliance)',
      f6: 'AI-powered analytics',
      b1: 'Domestic and national solution',
      b2: 'ISO 27001 certified',
      b3: 'TÜBİTAK-supported R&D',
      b4: 'Turkish language support',
    },
  },
  zebra: {
    partnerBadge: 'Zebra Authorized Sales Partner',
    title: 'Zebra Printers and Barcode Products',
    desc: 'ELC Teknoloji San ve Tic Ltd Şti offers Zebra Technologies branded barcode printers, mobile handheld terminals, and accessory sales with product consultancy across Turkey.',
    p1Title: 'Mobile Handheld Terminals',
    p1Desc: 'High-performance mobile handheld terminals for warehouse, logistics, and field operations.',
    p1f1: 'Rugged Design', p1f2: 'Long Battery Life', p1f3: 'Fast Scanning', p1f4: 'Android OS',
    p2Title: 'Zebra Printers',
    p2Desc: 'Industrial and desktop barcode printers for your labeling needs.',
    p2f1: 'High Print Quality', p2f2: 'Fast Printing', p2f3: 'Easy to Use', p2f4: 'Low Maintenance Cost',
    p3Title: 'Barcode Scanners',
    p3Desc: 'Professional barcode scanner solutions for retail, warehouse, and manufacturing environments.',
    p3f1: '1D/2D Scanning', p3f2: 'Wireless Connection', p3f3: 'Ergonomic Design', p3f4: 'Fast Reading',
    p4Title: 'Mobile Computers',
    p4Desc: 'Rugged mobile computers and tablet solutions for harsh environments.',
    p4f1: 'IP67 Protection', p4f2: 'Wide Display', p4f3: 'Powerful Processor', p4f4: 'Integrated Scanner',
    whyBadge: 'Why ELC Teknoloji?',
    whyTitle: 'Your Trusted Zebra Products Partner',
    whyDesc: 'We recommend the right Zebra barcode solutions for warehouse, logistics, manufacturing, retail, and field operations based on your needs.',
    why1: 'Nationwide Sales & Fast Supply',
    why2: 'Expertise in Zebra Products',
    why3: 'Business-Specific Product Consultancy',
    why4: 'Enterprise and SMB Focused Solutions',
    why5: 'Pre-Sales & Post-Sales Support',
    ctaTitle: 'Quick Quote & Contact',
    ctaDesc: 'Contact us now to purchase Zebra printers, learn about barcode solutions, or find the most suitable model for your business.',
    ctaBtn: 'Get Quote',
  },
  contact: {
    badge: 'Contact',
    title: 'Get in Touch With Us',
    desc: 'Reach out to us for your inquiries. We will get back to you as soon as possible.',
    infoTitle: 'Contact Information',
    email: 'Email',
    phoneLabel: 'Phone / WhatsApp',
    hours: 'Working Hours',
    hoursValue: 'Monday - Friday: 09:00 - 18:00',
    quickSupport: 'Quick Support',
    quickSupportDesc: 'For urgent situations, you can reach us via WhatsApp. We will get back to you as soon as possible.',
    formTitle: 'Send a Message',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailLabel: 'Your Email',
    phoneInput: 'Your Phone',
    messageLabel: 'Your Message',
    messagePlaceholder: 'Write your message here...',
    submit: 'Send',
    sending: 'Sending...',
    successTitle: 'Thank You!',
    successDesc: 'Your message has been sent successfully. We will get back to you as soon as possible.',
    successToast: 'Your message has been sent successfully!',
    errorToast: 'Message could not be sent. Please try again.',
    newMessage: 'Send New Message',
    officesTitle: 'Our Office Locations',
    officesDesc: 'We serve you from the nearest point with our offices in Turkey and the USA.',
    merkez: 'HEADQUARTERS',
    gebze: 'GEBZE OFFICE',
    usa: 'USA OFFICE',
    taxOffice: 'Tax Office',
    taxNumber: 'Tax Number',
  },
  profServices: {
    badge: 'Professional IT & OT Services',
    title1: 'Value-Added',
    title2: 'Professional Services',
    desc: 'Consulting, installation, operations & maintenance, SOC, training, red team solutions, and cyber incident response services.',
    navConsulting: 'Consulting',
    navInstallation: 'Installation',
    navOperation: 'Operations & Maint.',
    navSoc: 'SoC',
    navRedteam: 'Red Team',
    navIncident: 'Incident Response',
    navTraining: 'Academy',
    s1Title: 'Analysis and Consulting',
    s1Desc: 'We analyze your existing infrastructure, identify gaps, and create future-oriented architectural designs.',
    s2Title: 'Installation and Integration',
    s2Desc: 'We integrate the latest technology products into your organization, ensuring seamless transition processes.',
    s3Title: 'Operations and Maintenance (SLA)',
    s3Desc: 'We ensure uninterrupted operation of your systems with SLA-guaranteed professional operations and maintenance services.',
    slaWeekday: 'Weekdays, 08:00–18:00',
    sla247: '7 days, 24 hours',
    s4Title: 'On-Prem SoC Services',
    s4Desc: 'Security operations management 24/7 with our on-site SoC services.',
    blueTeam: 'Blue Team SoC Services',
    redTeamSoc: 'Red Team SoC Services',
    s5Title: 'Red Team Cybersecurity Services',
    s5Desc: 'Test your security with BAS, attack simulations, and tabletop exercise services.',
    s6Title: 'Cyber Incident Response Services',
    s6Desc: 'Fast, effective response and recovery services against cyber attacks.',
    s7Title: 'Cybersecurity Academy',
    s7Desc: 'Comprehensive training programs combining theoretical knowledge with practical experience from expert instructors.',
    ctaTitle: 'Get a Quote',
    ctaDesc: 'Request a quote for customized service packages tailored to your needs and organization scale. We will get back to you shortly.',
    ctaBtn: 'Contact Us',
  },
};

export const translations = { tr, en };
